<div class="banner-container">
    <a
        *ngIf="promoData.link"
        [href]="promoData.link"
        [attr.target]="promoData.target"
        [name]="promoData.analyticsProgressionLinkId"
        class="banner-link">
        <ng-container *ngTemplateOutlet="prommoBannerContent"></ng-container>
    </a>

    <div
        class="banner"
        *ngIf="!promoData.link">
        <ng-container *ngTemplateOutlet="prommoBannerContent"></ng-container>
    </div>
</div>

<ng-template #prommoBannerContent>
    <div *ngIf="promoData.title"
        class="banner-text-container"
        [ngClass]="textClass">
        <h2 class="banner-title"
            [innerHTML]="promoData.title | safeHtml"
        ></h2>
        <h3 class="banner-subtitle"
            [innerHTML]="promoData.subtitle | safeHtml"
        ></h3>
    </div>
    <finder-picture
        (mouseenter)="srcGroup = hoverImages"
        (mouseleave)="srcGroup = images"
        class="image-container"
        [picture]="srcGroup"
    ></finder-picture>
</ng-template>

